$shm_hitalama_guide_drag $shm_hitalama_dragtree
	catalog $shm_hitalama_guide_catalog
	locked false
	drag_hold_delay 300
	drag_touch_action \auto
	drop_root_gutter true
	drop_folder_edges true
